/**
 * Legacy strings for سجل النظام and سجل التنبيهات —
 * Admin/SystemState.ar.resx, Admin/NotificationsDetails.ar.resx and Locale/Resources.ar.resx.
 */
export const systemStateStrings = {
  title: 'حالة النظام', // SystemState.PageResource1_Title
  tab: 'النشاطات الأخيرة', // SystemState.LocalizeResource2_Text

  columns: {
    index: 'م', // LatestActivities_HeaderText1
    username: 'اسم المستخدم', // LatestActivities_HeaderText2
    activity: 'نوع النشاط', // LatestActivities_HeaderText3
    activityDate: 'تاريخ النشاط', // LatestActivities_HeaderText4
  },

  subtitle: 'كل ما قام به المستخدمون في النظام، الأحدث أولاً',
  searchPlaceholder: 'ابحث باسم المستخدم أو نوع النشاط',
  empty: 'لا توجد نشاطات مطابقة',
  actionFailed: 'تعذر تحميل السجل',

  /* Not legacy — the log listed its rows and said nothing about them. Only two figures
     survive server paging; see the note on the page. */
  summary: {
    caption: 'ملخص السجل',
    total: 'إجمالي النشاطات',
    latest: 'آخر نشاط',
  },

  exportNote: 'التصدير غير متاح من هذه الشاشة بعد — لم تُنقل هذه العملية إلى الواجهة البرمجية.',

  exportExcel: 'تصدير الى Excel', // UsersPoliciesDetails.ExportExcelImageButtonResource1_AlternateText
  exportPdf: 'تصدير الى PDF', // UsersPoliciesDetails.ExportPDFImageButtonResource1_AlternateText
}

export const notificationsLogStrings = {
  title: 'تفاصيل التنبيهات', // NotificationsDetails.MainPanelHeader

  columns: {
    type: 'النوع', // Type
    status: 'الحاله', // Status
    createdOn: 'تاريخ الجدولة', // CreatedOn
    startDate: 'تاريخ البداية', // StartDate
    endDate: 'تاريخ النهاية', // EndDate
  },

  messageColumns: {
    status: 'الحاله', // Status
    lastStatusDate: 'تاريخ آخر حاله', // Last_Status_Date
    details: 'التفاصيل', // Details
  },

  filter: 'بحث', // Filter
  reset: 'إلغاء', // Reset
  type: 'النوع', // Type
  status: 'الحاله', // Status
  details: 'التفاصيل', // Details
  preview: 'عرض', // Preview
  delete: 'حذف', // Delete
  close: 'إغلاق', // NotificationsDetails.btnClose
  deleteConfirm: 'هل أنت متأكد من حذف التنبيه الذي تم إختياره؟', // NotificationsDetails.DeleteConfirm
  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  deleteFailed: 'فشلت العملية', // operationFailed
  yes: 'نعم', // Yes
  no: 'لا', // No

  /** getStatusString in NotificationsDetails/js.cshtml — the state is stored as its name. */
  states: {
    Waiting: 'في الإنتظار',
    Running: 'جارية',
    Stopped: 'توقفت',
    Finished: 'إنتهت',
    Failed: 'فشلت',
    Succeeded: 'نجحت',
  },

  /** Only a waiting batch can be deleted. */
  deletableState: 'Waiting',
}
